<template>
	<a-config-provider :locale="locale" :auto-insert-space-in-button="false">
		<a-layout id="bbs_layout" class="bbs-layout">
			<!--仅在客户端渲染-->
			<client-only>
				<!--网站顶部导航栏-->
				<bbs-navbar ref="navbar" />
			</client-only>
			<a-layout-content ref="main" class="bbs-content">
				<nuxt />
			</a-layout-content>
			<client-only>
				<!--网站底部页脚-->
				<bbs-footer ref="footer" />
				<bbs-im ref="im" @onConnected="sendWelcome" />
			<!--	<book-dialog />-->
				<login-dialog />
				<logout-dialog />
				<bbs-action-side @openIm="openIm" v-show="$route.name!='index'&&$route.name!='lang'&&$route.name!='live'&&$route.name!='lang-live'" />
			</client-only>
      <client-only>
        <xiaozimaIM ref="imRef" />
      </client-only>
		</a-layout>
	</a-config-provider>
</template>

<script>
	import zh_CN from 'ant-design-vue/lib/locale-provider/zh_CN'
	import Cookies from 'js-cookie'
	const BbsIm = () => import('@/components/im/index')
	const BbsNavbar = () => import('@/components/layout/bbs-navbar')
	const BbsFooter = () => import('@/components/layout/bbs-footer')
	const BbsActionSide = () => import('@/components/layout/bbs-action-side')
	const LoginDialog = () => import('@/components/modal/login-dialog')
	const LogoutDialog = () => import('@/components/modal/logout-dialog')
	const BookDialog = () => import('@/components/modal/book-dialog')
  import xiaozimaIM from "@/components/xiaozimaIM";
	export default {
		components: { BbsIm, BookDialog, LogoutDialog, LoginDialog, BbsActionSide, BbsNavbar, BbsFooter,xiaozimaIM },
		data() {
			return {
				height: 0,
				customer: {},
				locales: { zh_CN },
				fromAccid: null,
				connected: false,
				user: this.$store.state.user,
       			actionSide:false
			}
		},
		computed: {
			locale() {
				return this.locales[this.$store.state.locale]
			},
			isHome() {
				const me = this, { path } = me.$route
				return path.replace(me.$store.state.locale, '').replace(/\/+/, '/') === '/'
			}
		},
		created(){
			if(process.browser)this.initStoreBaseInfo();
		},
		beforeMount(){
			window.$nuxt = this;
			if(window.__NUXT__)window.__NUXT__.logs = [];
		},
		mounted() {
      window.addEventListener('scroll', this.getScroll);
			if (Cookies.get('userInfo')) {
				this.$store.commit('SET_USER', JSON.parse(Cookies.get('userInfo')))
			}
			// this.init()
		},
    destroyed(){
      window.removeEventListener('scroll', this.getScroll);
    },
		methods: {
      getScroll(){
        if (!!document.documentElement.scrollTop &&document.documentElement.scrollTop >= 800){
          if(this.actionSide) return
          this.actionSide = true
        }else{
          if(!this.actionSide)return;
          this.actionSide = false
        }
      },
      openIm(){
        this.$refs.imRef.openIm()
      },
			initStoreBaseInfo() {
				let userInfo = this.$cookies.get("userInfo");
				let lawyerInfo = this.$cookies.get("lawyerInfo");
				let token = this.$cookies.get("token");
				this.$nextTick(function () {
					if (userInfo) this.$store.commit("SET_USER", userInfo);
					if (lawyerInfo) this.$store.commit("UPDATELAWYERDATA", lawyerInfo);
					if (token) this.$store.commit("SET_TOKEN", token);
				})
			},
			sendWelcome() {
				const me = this

				return me.$axios.$post('im/send/template', {
					fromAccid: me.fromAccid,
					toAccid: me.customer.accid,
					templates: ['welcome_forum']
				})
			}
		}
	}
</script>
<style lang="scss" scoped>
	.bbs-layout {
		min-height: 100%;
		background: transparent;

		.bbs-content {
			min-height: auto;
			margin-top: 85px;
			// margin-top: 122px;
      //padding-top: 99px;
		}
	}
</style>
<style>
	html,
	body,
	#__layout,
	#__nuxt {
		height: 100%;
	}

	body>a:first-child {
		display: none;
	}

	html {
		font-family: "Source Sans Pro", -apple-system, BlinkMacSystemFont,
			"Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif;
		font-size: 16px;
		word-spacing: 1px;
		-ms-text-size-adjust: 100%;
		-webkit-text-size-adjust: 100%;
		-moz-osx-font-smoothing: grayscale;
		-webkit-font-smoothing: antialiased;
		box-sizing: border-box;
	}

	*,
	*:before,
	*:after {
		margin: 0;
		outline: none;
		box-sizing: border-box;
	}
</style>
